import { useState } from "react";
import { Grid, Button, CircularProgress, Box, Typography } from "@mui/material";
import ArtistEdit from "../ArtistEdit";
import Artist from "../../components/Artist";
import { ArtistLoadMoreButtonSx, ArtistsAddButtonSx } from "./styles";
import { useArtists } from "../../hooks/useArtists";

const ArtistsTab = () => {
  const [editArtist, setEditArtist] = useState({ modalOpen: false, id: undefined });
  const { data, isLoading, hasMore, loadMore } = useArtists();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Typography
          variant="overline"
          sx={{ color: "rgba(255,255,255,0.4)", letterSpacing: "0.2em", fontSize: "0.68rem" }}
        >
          Artists
        </Typography>
        <Button
          variant="outlined"
          onClick={() => setEditArtist({ modalOpen: true, id: undefined })}
          sx={ArtistsAddButtonSx}
        >
          + Add Artist
        </Button>
      </Box>

      {isLoading && !data.length ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
          <CircularProgress sx={{ color: "rgba(255,255,255,0.35)" }} />
        </Box>
      ) : (
        <Grid container gap={2.5}>
          {data.map(({ name, stageName, _id, imageURL }) => (
            <div
              key={_id}
              onClick={() => setEditArtist({ modalOpen: true, id: _id })}
              style={{ cursor: "pointer" }}
            >
              <Artist image={imageURL} name={name} stageName={stageName} isAdminPage={true} />
            </div>
          ))}
        </Grid>
      )}

      {hasMore && (
        <Button
          variant="outlined"
          onClick={loadMore}
          disabled={isLoading}
          sx={ArtistLoadMoreButtonSx}
        >
          {isLoading && data.length ? (
            <CircularProgress size={14} sx={{ color: "rgba(255,255,255,0.4)" }} />
          ) : (
            "Load More"
          )}
        </Button>
      )}

      <ArtistEdit
        open={editArtist.modalOpen}
        artistId={editArtist.id}
        closeModal={() => setEditArtist({ modalOpen: false, id: undefined })}
      />
    </>
  );
};

export default ArtistsTab;
